import SocialUserProfile from '../../Views/Social/UserProfile';

export default [
    {
        path:'/u/:uuid',
        component:SocialUserProfile,
        name:'social.userprofile',
    },
];
